/* La barra lateral del panel, según "Klavia Dashboard v2" (Claude Design 9cf061f2): blanca, 248 px,
   contraíble a 68. El ítem activo lleva accent-50 de fondo, un anillo accent-100 y el icono violeta.
   Contraída, la etiqueta pasa a un cartel al costado y el contador a un punto sobre el icono. */
.nav {
  --_bg: var(--surface-card);
  --_field: var(--surface-sunken);
  --_active: var(--surface-brand-faint);
  --_active-ring: inset 0 0 0 var(--bw-hair) var(--border-brand-soft);
  --_hover: var(--action-quiet-hover);
  /* Entre --r-md y --r-lg: el radio de los ítems y del campo en el mock. */
  --_r-item: 10px;

  position: sticky;
  top: 0;
  align-self: flex-start;
  height: 100vh;
  height: 100dvh;
  width: var(--w-sidebar);
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  gap: var(--s-7);
  padding: var(--s-7) var(--s-5);
  background: var(--_bg);
  color: var(--text-strong);
  border-right: var(--bw-hair) solid var(--border-hair);
  font-family: var(--font-body);
  overflow: visible;
  transition: width var(--dur-base) var(--ease-standard);
}
.nav[data-tone="gray"] {
  --_bg: var(--surface-muted);
  --_field: var(--surface-card);
  --_active: var(--surface-card);
  --_active-ring: var(--sh-xs), 0 0 0 var(--bw-hair) var(--border-hair);
  --_hover: var(--action-quiet-active);
}
.nav[data-collapsed="true"] {
  width: var(--w-sidebar-collapsed);
}

/* Cabecera: isologo, nombre y el botón de contraer. Contraída queda sólo el botón, centrado. */
.cabecera {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: var(--h-control-sm);
  padding: 0 var(--s-2) 0 var(--s-4);
}
/* El isologo real (`ISOLOGO_SRC`): mide lo mismo de alto que el botón de contraer y conserva su
   proporción. Nunca un cuadrado violeta con un glifo adentro. */
.isologo {
  display: block;
  height: 28px;
  width: auto;
  flex: none;
}
.logoImg {
  display: block;
  width: 28px;
  height: 28px;
  flex: none;
  border-radius: var(--r-md);
  object-fit: contain;
}
.wordmark {
  flex: 1;
  min-width: 0;
  font-family: var(--font-display);
  font-weight: var(--fw-bold);
  /* 17 en el mock: entre --fs-md y --fs-lg. */
  font-size: 17px;
  letter-spacing: var(--ls-wordmark);
  line-height: 1;
  color: var(--text-strong);
  white-space: nowrap;
  overflow: hidden;
}
.nav[data-collapsed="true"] .cabecera {
  padding: 0;
}
.nav[data-collapsed="true"] .isologo,
.nav[data-collapsed="true"] .logoImg,
.nav[data-collapsed="true"] .wordmark {
  display: none;
}
.toggle,
.accion {
  width: 28px;
  height: 28px;
  flex: none;
  padding: 0;
  border: none;
  border-radius: var(--r-md);
  background: transparent;
  color: var(--text-subtle);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background var(--dur-fast) var(--ease-standard);
}
.accion {
  width: 22px;
  height: 22px;
  border-radius: var(--r-sm);
}
.toggle:focus-visible,
.accion:focus-visible {
  outline: none;
  box-shadow: var(--ring-focus);
}

/* Búsqueda: un campo hundido con el atajo ⌘K. Contraída es sólo la lupa. */
.buscador {
  margin: 0;
}
.busqueda {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 38px;
  padding: 0 var(--s-5);
  border-radius: var(--_r-item);
  background: var(--_field);
  border: var(--bw-hair) solid var(--border-hair);
  color: var(--text-subtle);
  cursor: text;
  transition:
    border-color var(--dur-fast) var(--ease-standard),
    box-shadow var(--dur-fast) var(--ease-standard);
}
.busqueda:focus-within {
  border-color: var(--border-brand);
  box-shadow: var(--ring-focus);
}
.campo {
  flex: 1;
  min-width: 0;
  padding: 0;
  border: none;
  background: transparent;
  outline: none;
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  color: var(--text-strong);
  -webkit-appearance: none;
  appearance: none;
}
.campo::placeholder {
  color: var(--text-subtle);
}
.campo::-webkit-search-decoration,
.campo::-webkit-search-cancel-button {
  -webkit-appearance: none;
}
.atajo {
  font-family: var(--font-mono);
  font-size: 10px;
  line-height: 1;
  color: var(--text-subtle);
  border: var(--bw-hair) solid var(--border-hair);
  border-radius: 5px;
  padding: var(--s-1) 5px;
}
.busquedaContraida {
  display: none;
  width: 100%;
  height: var(--h-control-md);
  padding: 0;
  border-radius: var(--_r-item);
  border: var(--bw-hair) solid var(--border-hair);
  background: var(--_field);
  color: var(--text-muted);
  cursor: pointer;
  align-items: center;
  justify-content: center;
  transition: border-color var(--dur-fast) var(--ease-standard);
}
.busquedaContraida:focus-visible {
  outline: none;
  box-shadow: var(--ring-focus);
}
.nav[data-collapsed="true"] .busqueda {
  display: none;
}
.nav[data-collapsed="true"] .busquedaContraida {
  display: flex;
}

/* Ítems: 13px, radio 10, icono de 18 en gray-500. */
.items {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--s-1);
}
.item {
  position: relative;
  display: flex;
  align-items: center;
  gap: var(--s-5);
  width: 100%;
  padding: 9px var(--s-5);
  border: none;
  border-radius: var(--_r-item);
  background: transparent;
  color: var(--text-body);
  cursor: pointer;
  text-align: left;
  text-decoration: none;
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  font-weight: var(--fw-medium);
  line-height: 1.4;
  transition:
    background var(--dur-fast) var(--ease-standard),
    color var(--dur-fast) var(--ease-standard);
}
.item[aria-current="page"] {
  background: var(--_active);
  box-shadow: var(--_active-ring);
  color: var(--text-strong);
  font-weight: var(--fw-semibold);
}
.item:focus-visible {
  outline: none;
  box-shadow: var(--ring-focus);
}
.icono {
  position: relative;
  display: block;
  width: 18px;
  height: 18px;
  flex: none;
  color: var(--text-muted);
}
.item[aria-current="page"] .icono {
  color: var(--text-brand);
}
.punto {
  display: none;
  position: absolute;
  top: -3px;
  right: -4px;
  width: var(--s-4);
  height: var(--s-4);
  border-radius: var(--r-full);
  background: var(--surface-brand);
  border: var(--bw-thick) solid var(--_bg);
}
.label {
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.contador {
  font-size: var(--fs-3xs);
  font-weight: var(--fw-bold);
  line-height: 1.4;
  color: var(--text-inverse);
  background: var(--surface-brand);
  border-radius: var(--r-full);
  padding: var(--s-1) var(--s-4);
}
.tip {
  display: none;
  position: absolute;
  left: calc(100% + 14px);
  top: 50%;
  transform: translateY(-50%);
  z-index: var(--z-popover);
  padding: var(--s-3) 10px;
  border-radius: var(--r-md);
  background: var(--surface-inverse);
  color: var(--text-inverse);
  font-size: var(--fs-2xs);
  font-weight: var(--fw-semibold);
  line-height: var(--lh-normal);
  white-space: nowrap;
  box-shadow: var(--sh-lg);
  pointer-events: none;
}
/* Contraída: icono centrado; la etiqueta y el contador quedan sólo para el lector de pantalla. */
.nav[data-collapsed="true"] .item {
  padding: 11px 0;
  justify-content: center;
}
.nav[data-collapsed="true"] .label,
.nav[data-collapsed="true"] .contador {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}
.nav[data-collapsed="true"] .punto {
  display: block;
}
.nav[data-collapsed="true"] .item:focus-visible .tip {
  display: block;
}

/* Secciones secundarias (Carpetas, Integraciones): encabezado gris con el chevron y los ítems debajo. */
.seccion {
  display: flex;
  flex-direction: column;
  gap: var(--s-1);
}
.seccionCabecera {
  display: flex;
  align-items: center;
  gap: var(--s-3);
  padding: var(--s-2) var(--s-4) var(--s-3);
}
.seccionTitulo {
  flex: 1;
  min-width: 0;
  font-size: var(--fs-2xs);
  font-weight: var(--fw-semibold);
  color: var(--text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.regla {
  display: none;
  height: var(--bw-hair);
  background: var(--border-hair);
  margin: 0 10px var(--s-4);
}
.nav[data-collapsed="true"] .seccionCabecera {
  display: none;
}
.nav[data-collapsed="true"] .seccion[data-pinned] .regla {
  display: block;
}
.nav[data-collapsed="true"] .seccion:not([data-pinned]) {
  display: none;
}

.pie {
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: var(--s-4);
}

@media (hover: hover) {
  .toggle:hover,
  .accion:hover {
    background: var(--action-quiet-hover);
  }
  .busqueda:hover,
  .busquedaContraida:hover {
    border-color: var(--border-strong);
  }
  .item:hover {
    background: var(--_hover);
    color: var(--text-strong);
  }
  .item[aria-current="page"]:hover {
    background: var(--_active);
  }
  .nav[data-collapsed="true"] .item:hover .tip {
    display: block;
  }
}

/* Celular: barra inferior fija con los ítems principales. La cabecera, la búsqueda, las
   secciones y el pie no entran; el título de cada pantalla ya dice dónde estás. */
@media (max-width: 767px) {
  .nav,
  .nav[data-collapsed="true"] {
    position: fixed;
    inset: auto 0 0 0;
    z-index: var(--z-bar);
    width: auto;
    height: auto;
    flex: none;
    flex-direction: row;
    gap: 0;
    padding: var(--s-2) var(--s-2) calc(var(--s-2) + env(safe-area-inset-bottom));
    border-right: none;
    border-top: var(--bw-hair) solid var(--border-hair);
    transition: none;
  }
  .cabecera,
  .buscador,
  .seccion,
  .pie {
    display: none;
  }
  .nav > nav {
    flex: 1;
    min-width: 0;
  }
  .items {
    flex-direction: row;
    gap: 0;
  }
  .items > li {
    flex: 1;
    min-width: 0;
  }
  .item,
  .nav[data-collapsed="true"] .item {
    flex-direction: column;
    justify-content: center;
    gap: var(--s-1);
    height: var(--h-control-lg);
    padding: 0 var(--s-1);
    font-size: var(--fs-3xs);
    text-align: center;
  }
  .item[aria-current="page"] {
    box-shadow: inset 0 var(--bw-thick) 0 var(--border-brand);
  }
  .label,
  .nav[data-collapsed="true"] .label {
    position: static;
    width: 100%;
    height: auto;
    clip: auto;
    text-align: center;
  }
  .contador,
  .nav[data-collapsed="true"] .contador {
    position: absolute;
    top: var(--s-1);
    right: var(--s-2);
    width: auto;
    height: auto;
    clip: auto;
    padding: 0 var(--s-2);
  }
  .nav[data-collapsed="true"] .punto,
  .nav[data-collapsed="true"] .item:hover .tip,
  .nav[data-collapsed="true"] .item:focus-visible .tip {
    display: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .nav,
  .item,
  .toggle,
  .accion,
  .busqueda,
  .busquedaContraida {
    transition: none;
  }
}

/* Foco único: el campo heredado comparte el anillo de su contenedor. */
.campo:focus-visible { outline: none; box-shadow: none; }
.disparador { width: 100%; font-family: var(--font-body); font-size: var(--fs-xs); cursor: pointer; text-align: left; }
.disparador:focus-visible { outline: none; border-color: var(--border-brand); box-shadow: var(--ring-focus); }
.textoBusqueda { flex: 1; min-width: 0; }

.busquedaMovil { display: none; }
@media (max-width: 767px) { .busquedaMovil { display: block; } }
